import { atom } from 'recoil';

// The matches for the current search. A registration can be reused once a
// vessel is deleted, and a name search can legitimately hit several, so the
// user picks rather than being handed an arbitrary one.
export const vesselFinderResultsState = atom({
    key: 'vesselFinderResultsState',
    default: [],
});

// The one currently being shown in detail.
export const vesselFinderResultState = atom({
    key: 'vesselFinderResultState',
    default: null,
});

export const vesselFinderSearchState = atom({
    key: 'vesselFinderSearchState',
    default: '',
});
